// Rol "Supervisor DPS" (Prosperidad Social). Mismo valor que sec_users.role y
// sec_groups.group_id (convención del sistema: role = group_id). Ver
// backend/sql/rol_supervisor_dps.sql y backend/src/utils/roles/rolesUtils.ts.
export const ROL_SUPERVISOR_DPS = "4";

export const esSupervisorDps = (user) => String(user?.role ?? "") === ROL_SUPERVISOR_DPS;

// Únicas rutas que puede abrir este rol (además del login y la página de
// acceso restringido). El menú ya se filtra por sec_groups_apps; esto evita
// además que entre a otros módulos escribiendo la URL a mano.
const RUTAS_SUPERVISOR_DPS = [
  "/inicio",
  "/reporteRitEntregas",
  "/reporteRitEntregas2",
  "/reporteRitEntregas3",
  "/autorizados-entregas",
  "/validador-imagenes",
  "/InformeReportes",
  "/InformeGeneralEntregas",
];

export const rutaPermitidaSupervisorDps = (pathname) =>
  RUTAS_SUPERVISOR_DPS.some((ruta) => pathname === ruta || (ruta === "/inicio" && pathname.startsWith("/inicio/")));
